<app-glass-house-shelf-talker-content
  [data]="data"
  [parentWidth]="parentHeight"
  [parentHeight]="parentHeight"
  [preview]>
</app-glass-house-shelf-talker-content>
